import Board from "./components/Board/presentation";
import Answer from "./components/Answer/presentation";
import { useState, useEffect } from "react";
import ResultModal from "./components/Result/presentation";
import MistakeModal from "./components/Mistake/presentation";
import Anounce from "./components/Anounce/presentation";
import { Box } from "@mui/material";
import Header from "./Header";
import Footer from "./Footer";
import useGA from "./hooks/useGA";
import useChallengeIndex from "./hooks/useChallengeIndex";
import { useChallenges } from "./hooks/firebase/useChallenges";

function App() {
  useGA();

  const challengeIndex = useChallengeIndex();
  const { docData, loading } = useChallenges(challengeIndex);
  const [answer, setAnswer] = useState<string>("");
  const [numOfCorrectAnswers, setNumOfCorrectAnswers] = useState(0);
  const [isMistaken, setIsMistaken] = useState<boolean>(false);
  const [timesOfAnswers, setTimesOfAnswers] = useState<number>(0);

  useEffect(() => {
    answer !== "" && setNumOfCorrectAnswers((n) => n + 1);
  }, [answer]);

  if (loading) {
    return <div>loading...</div>;
  }

  const pagesTotal = 6;
  if (Number(challengeIndex) >= pagesTotal - 1) return <Anounce />;

  //データが取得できてから定義する
  //告知ページのときは読み込めないので、それより後に定義する
  const challengeWords: string[][] = docData?.challengeWords.map(
    (word: string) => Array.from(word)
  );
  const charsWithoutChip: string[] = Array.from(docData?.charsWithoutChip);
  const lostChars: string[] = Array.from(docData?.lostChars);
  const isShown = numOfCorrectAnswers >= lostChars.length;
  const wordNumMax = challengeWords.reduce(
    (len, word) => Math.max(len, word.length),
    0
  );

  return (
    <Box>
      <Header />
      <Box
        sx={{
          display: "flex",
          flexDirection: {
            xs: "column",
            md: "row",
          },
          justifyContent: { xs: "center", md: "center" },
          alignItems: "center",
          maxHeight: { md: "600px" },
          mt: { xs: 1, md: 2 },
        }}
      >
        <Board
          setAnswer={setAnswer}
          timesOfAnswers={timesOfAnswers}
          setTimesOfAnswers={setTimesOfAnswers}
          setIsMistaken={setIsMistaken}
          isShown={isShown}
          theme={docData?.theme}
          lostChars={docData?.lostChars}
          charsWithoutChip={charsWithoutChip}
        />
        {/* ちょっかんくん */}
        <Box
          flexDirection="column"
          mx={wordNumMax === 3 ? 8 : 2}
          sx={{ mt: { xs: "10px", md: 0 } }}
        >
          {challengeWords.map((word: string[], index: number) => {
            return (
              <Answer
                key={`challengeWord_${index}`}
                answer={answer}
                word={word}
                wordIndex={index}
                numOfCorrectAnswers={numOfCorrectAnswers}
                setNumOfCorrectAnswers={setNumOfCorrectAnswers}
                correctWords={docData?.correctWords}
                isCompleted={isShown}
              />
            );
          })}
        </Box>
        {isShown && (
          <ResultModal
            timesOfAnswers={timesOfAnswers}
            lostChars={lostChars}
            challengeWords={docData?.challengeWords}
            challengeIndex={challengeIndex}
            pagesTotal={pagesTotal}
          />
        )}
        {isMistaken && <MistakeModal />}
      </Box>
      <Footer hintMessage={docData?.hintMessage} />
    </Box>
  );
}

export default App;
